module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/duran/duran-web/src/app/menu/menu.component.html
// module id = ../../../../../src/app/menu/menu.component.html
// module chunks = main